var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("v-data-table", {
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      loading: _vm.filters.filter_by_user_loading_status
    },
    scopedSlots: _vm._u([
      {
        key: "item.actions",
        fn: function fn(_ref) {
          var item = _ref.item
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  color: "primary",
                  to: _vm.manageLink(item)
                }
              },
              [_vm._v(" Manage ")]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }